<template>
  <div>
    <place-picker-map
      :center="position"
      :options="options"
      :visible="isVisible"
      :marker-icon="markerIcon"
      :is-marker-visible="isMarkerVisible"
      :is-active="isActive"
      :marker-position="position"
      @loaded="setPlacePickerLoaded"
      @click="handleMapClick"
      @mount="handleMapMount"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  SET_PLACE_PICKER_LOADED,
  SET_PLACE_PICKER_POSITION,
  SET_PLACE_TITLE
} from '@/store/mutation-types'
import PlacePickerMap from '@/containers/PlacePicker/PlacePickerMap'

import {
  PICK_MAP_CONFIG,
  PICK_MARKER_CONFIG
} from '@/assets/js/map'

export default {
  components: {
    PlacePickerMap
  },
  data () {
    return {
      options: PICK_MAP_CONFIG,
      markerIcon: PICK_MARKER_CONFIG
    }
  },
  computed: {
    ...mapState({
      isActive: state => state.picker.isActive,
      isVisible: state => state.picker.isVisible,
      position: state => state.picker.position,
      isValid: state => state.picker.isValid,
      placeId: state => state.picker.placeId,
      wasChanged: state => state.picker.wasChanged
    }),
    isMarkerVisible () {
      return this.isActive && this.isValid && this.wasChanged
    }
  },
  watch: {
    placeId () {
      if (this.placeId) this.setPositionByPlace()
    }
  },
  methods: {
    ...mapMutations({
      setPlacePickerLoaded: SET_PLACE_PICKER_LOADED,
      setPlacePickerPosition: SET_PLACE_PICKER_POSITION,
      setPlaceTitle: SET_PLACE_TITLE
    }),
    handleMapClick (coords) {
      if (!coords) return
      this.setPlacePickerPosition(coords)

      const geocoder = new google.maps.Geocoder()
      const req = { location: coords }
      geocoder.geocode(req, (results = [], status) => {
        if (status === 'OK' && results[0]) {
          this.setPlaceTitle(results[0].formatted_address.replace(/,.*$/, ''))
        }
      })
    },
    handleMapMount (ref) {
      this.service = new google.maps.places.PlacesService(ref)
    },
    setPositionByPlace () {
      if (!this.service) return

      const req = { placeId: this.placeId, fields: ['geometry'] }
      this.service.getDetails(req, res => {
        this.setPlacePickerPosition({
          lat: res.geometry.location.lat(),
          lng: res.geometry.location.lng()
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/PlacePicker/PlacePickerContainer.vue